// Keep legacy action bodies and dispatch order unchanged.
/* eslint-disable import/order, arrow-body-style */
import type { SetPositionCategoryType } from 'utils/apiList/setPosition'
import type { DispatchFnType } from 'storeContext/types'
import type {
  SetPositionActionType,
  SetPositionPaginationType,
} from 'storeContext/reducers/setPosition'
import { toastFailed } from 'utils/toast'
import {
  SET_IS_START_SETPOS,
  SET_IS_FAILED_SETPOS,
  SET_IS_SUCCESS_SETPOS,
  SET_IS_PAGINATION_DATA_SETPOS,
  SET_IS_NEEN_TO_RELOAD_SETPOS,
} from 'storeContext/actionsType/setPosition'
import { getPPCatParent_SL } from 'utils/apiList/setPosition'

export const startSetPos = (): SetPositionActionType => {
  return {
    type: SET_IS_START_SETPOS,
  }
}

export const stopSetPos = (): SetPositionActionType => {
  return {
    type: SET_IS_FAILED_SETPOS,
  }
}

export const getSetPosData = (data: SetPositionCategoryType[]): SetPositionActionType => {
  return {
    type: SET_IS_SUCCESS_SETPOS,
    payload: data,
  }
}

export const setPaginationSetPos = (data: SetPositionPaginationType): SetPositionActionType => {
  return {
    type: SET_IS_PAGINATION_DATA_SETPOS,
    payload: data,
  }
}

export const getReloadData = (): SetPositionActionType => {
  return {
    type: SET_IS_NEEN_TO_RELOAD_SETPOS,
  }
}

export const getSetPosition = (query: string) => (dispatch: DispatchFnType) => {
  dispatch(startSetPos())

  return getPPCatParent_SL(query)
    .then(({ data }) => {
      // console.log(data);
      dispatch(getSetPosData(data))
    })
    .catch(() => {
      dispatch(stopSetPos())

      toastFailed('terjadi masalah, coba beberapa saat lagi')
    })
}
